<div class="grid-4col gap pt-3">
    <app-number-input
        class="fr-2"
        id="percent"
        [form]="form"
        [prefix]="prefix"
        [min]="0"
        [max]="100"
    ></app-number-input>

    <app-date-input id="validFrom" [form]="form" [prefix]="prefix"></app-date-input>
    <app-date-input id="validTo" [form]="form" [prefix]="prefix"></app-date-input>
</div>
